import { useEffect, useRef, useState } from 'react';
import { utcTodayIsoDate } from '../utils/statementPeriod';

export const UTC_DAY_CHECK_INTERVAL_MS = 60_000;

export function useUtcToday(now: () => Date = () => new Date()): string {
    const nowRef = useRef(now);
    const [todayIso, setTodayIso] = useState(() => utcTodayIsoDate(now()));

    useEffect(() => {
        nowRef.current = now;
    }, [now]);

    useEffect(() => {
        const refresh = () => setTodayIso(utcTodayIsoDate(nowRef.current()));
        const interval = window.setInterval(refresh, UTC_DAY_CHECK_INTERVAL_MS);
        document.addEventListener('visibilitychange', refresh);
        return () => {
            window.clearInterval(interval);
            document.removeEventListener('visibilitychange', refresh);
        };
    }, []);

    return todayIso;
}
